import { AlertDialog, Flex, Button } from '@scale/scaleui-radix';
import { twMerge } from 'tailwind-merge';

interface ConfirmationModalProps {
  trigger: React.ReactNode;
  onClose?: () => void;
  onAccept: () => void;
  title?: string;
  bodyText?: string;
  dismissText?: string;
  confirmationText?: string;
  disableTrigger?: boolean;
}

const ConfirmationDialog = ({
  trigger,
  onClose,
  onAccept,
  title = 'Confirm action',
  bodyText = 'Are you sure?',
  dismissText = 'Cancel',
  confirmationText = 'Confirm',
  disableTrigger = false,
}: ConfirmationModalProps) => {
  return (
    <AlertDialog.Root>
      <AlertDialog.Trigger
        className={twMerge(disableTrigger ? 'pointer-events-none cursor-not-allowed' : '')}
      >
        {trigger}
      </AlertDialog.Trigger>
      <AlertDialog.Content className="scaleui scale-theme scale-tailwind rt-reset" maxWidth="500px">
        {title && <AlertDialog.Title className="rt-reset">{title}</AlertDialog.Title>}
        <AlertDialog.Description className="my-3 rt-reset" size="2">
          {bodyText}
        </AlertDialog.Description>
        <Flex gap="3" justify="end">
          <AlertDialog.Cancel>
            <Button onClick={onClose} variant="soft" color="neutral">
              {dismissText}
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button onClick={onAccept} color="error">
              {confirmationText}
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
};

export default ConfirmationDialog;
